export const GET_PROTOCOL_PROFILE = "GET_PROTOCOL_PROFILE";
export const RESET_PROTOCOL_PROFILE = "RESET_PROTOCOL_PROFILE";